import React from 'react'
import { edited } from '@components/RichTextPlate/RichTextEditor.css'
import { Box, BoxProps } from '@ui'

export type EditedLabelProps = {
    withMargin?: boolean
} & Omit<BoxProps, 'children'>

export const EditedLabel = ({ withMargin = false, ...props }: EditedLabelProps) => {
    return (
        <Box
            as="span"
            display="inline-block"
            color="gray2"
            fontSize="sm"
            className={withMargin ? edited : undefined}
            {...props}
        >
            (edited)
        </Box>
    )
}
